import { SESSION_STORAGE_KEYS } from 'src/app/storage/sessionStorageKeys';

import { LAST_SHOWN_APP_DOWNLOAD_INTERSTITIAL } from './localStorageKeys';

/** Local Storage */

export const setLastShownAppDownloadInterstitialInLocalStorage = () => {
  window.localStorage.setItem(LAST_SHOWN_APP_DOWNLOAD_INTERSTITIAL, new Date().toString());
};

/** Session Storage */

export const markLogRocketInitialized = () => {
  window.localStorage.setItem(SESSION_STORAGE_KEYS.hasLogRocketBeenInitialized, 'true');
};

export const wipeLogRocketLocalStorageValue = () => {
  window.localStorage.removeItem(SESSION_STORAGE_KEYS.hasLogRocketBeenInitialized);
};

export const checkIfLogRocketInitialized = () => {
  return window.localStorage.getItem(SESSION_STORAGE_KEYS.hasLogRocketBeenInitialized) === 'true';
};
